import Home from "./components/Home";
import About from "./components/About";
import Services from "./components/Services";
import Packages from "./components/Packages";
import { Route, Routes, useLocation } from "react-router-dom";
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import { useEffect } from "react";

import PageNotFound from "./components/PageNotFoud";
import Forms from "./components/Forms";
import Facilities from "./components/Facilities";
import PackageDetails from "./components/PackageDetails";
import ChristmasFeatures from "./components/ChristmasFeatures";
import LaboratoryServices from "./components/LaboratoryServices";
import DigitalXrayServices from "./components/DigitalXrayServices";
import UltrasoundServices from "./components/UltrasoundServices";
import HsgServices from "./components/HsgServices";
import SonographyServices from "./components/SonographyServices";
import EcgServices from "./components/EcgServices";
import EchoServices from "./components/EchoServices";
import MobileConciergeServices from "./components/MobileConciergeServices";
import CorporateServices from "./components/CorporateServices";
import DNAServices from "./components/DNAServices";
import PFTServices from "./components/PFTServices";

function App() {
  const location = useLocation();
  useEffect(() => {
    // Start progress bar on route change
    nprogress.start();

    // Simulate load (or remove if real load is fast)
    const timer = setTimeout(() => {
      nprogress.done();
    }, 400); // 400ms minimum for visual effect

    return () => clearTimeout(timer);
  }, [location]);

  return (
    <>
      <main className="container-fluid ">
        <section className="row ">
          <ChristmasFeatures />

          <Routes style={{ padding: "2rem" }}>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/facilities" element={<Facilities />} />
            <Route path="/forms" element={<Forms />} />{" "}
            <Route
              path="/laboratoryServices"
              element={<LaboratoryServices />}
            />
            <Route
              path="/DigitalXrayServices"
              element={<DigitalXrayServices />}
            />
            <Route
              path="/UltrasoundServices"
              element={<UltrasoundServices />}
            />
            <Route
              path="/SonographyServices"
              element={<SonographyServices />}
            />
            <Route path="/HsgServices" element={<HsgServices />} />
            <Route path="/EcgServices" element={<EcgServices />} />
            <Route
              path="/MobileConciergeServices"
              element={<MobileConciergeServices />}
            />
            <Route path="/PFTServices" element={<PFTServices />} />
            <Route path="/EchoServices" element={<EchoServices />} />
            <Route path="/DNAServices" element={<DNAServices />} />
            <Route path="/CorporateServices" element={<CorporateServices />} />
            <Route path="/package-details" element={<PackageDetails />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </section>
      </main>
    </>
  );
}

export default App;
